import React from 'react';
import { useTranslation } from 'react-i18next';

function Process() {
  const { t } = useTranslation();
  
  const stages = [
    {
      number: '01',
      title: t('process.stage1.title'),
      time: t('process.stage1.time'),
      description: t('process.stage1.description'),
      result: t('process.stage1.result'),
      cost: t('process.stage1.cost')
    },
    {
      number: '02',
      title: t('process.stage2.title'),
      time: t('process.stage2.time'),
      description: t('process.stage2.description'),
      result: t('process.stage2.result'),
      cost: t('process.stage2.cost')
    },
    {
      number: '03',
      title: t('process.stage3.title'),
      time: t('process.stage3.time'),
      description: t('process.stage3.description'),
      result: t('process.stage3.result'),
      cost: t('process.stage3.cost')
    },
    {
      number: '04',
      title: t('process.stage4.title'),
      time: t('process.stage4.time'),
      description: t('process.stage4.description'),
      result: t('process.stage4.result'),
      cost: t('process.stage4.cost')
    }
  ];

  return (
    <section className="section process-section" id="process">
      <div className="container">
        <span className="section-label">{t('process.label')}</span>
        <h2 className="section-title">{t('process.title')}</h2>
        <p className="section-subtitle">{t('process.subtitle')}</p>

        <div className="process-timeline">
          {stages.map((stage, index) => (
            <React.Fragment key={stage.number}>
              <div className="process-stage animate-on-scroll">
                <div>
                  <span className="process-number">{stage.number}</span>
                  <h3 className="stage-title">{stage.title}</h3>
                  <div className="stage-time">{stage.time}</div>
                  <p className="stage-description">{stage.description}</p>
                  <p className="stage-result"><b>{stage.result}</b></p>
                </div>
                {stage.cost !== '' && stage.cost !== null && <div className="stage-cost">{stage.cost}</div>}

              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Process;
